// DOM helpers. Bank descriptors, merchants, notes, and any API-derived text are
// UNTRUSTED (CLAUDE.md): always textContent / createTextNode — never innerHTML
// with data, never eval. `h()` itself is XSS-safe (createTextNode only);
// `safeText` is the display convention used across pages for nullable/empty
// untrusted fields (fallback "—"), not an extra escape layer.

export type Child = Node | string | null | undefined;

export function h<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Record<string, string> = {},
  children: readonly Child[] = [],
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [name, value] of Object.entries(attrs)) {
    if (name === "class") {
      node.className = value;
    } else if (name.startsWith("data-") || name === "type" || name === "href" || name === "for" || name === "id" || name === "name" || name === "value" || name === "placeholder" || name === "aria-label" || name === "role" || name === "disabled" || name === "checked" || name === "selected" || name === "min" || name === "max" || name === "step" || name === "autocomplete") {
      node.setAttribute(name, value);
    } else {
      node.setAttribute(name, value);
    }
  }
  for (const child of children) {
    if (child === null || child === undefined) continue;
    node.append(typeof child === "string" ? document.createTextNode(child) : child);
  }
  return node;
}

export function clear(node: Element): void {
  while (node.firstChild) node.removeChild(node.firstChild);
}

/** Escape for attribute contexts when a value must go into setAttribute. */
export function escapeAttr(value: string): string {
  return value
    .replaceAll("&", "&amp;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;");
}

/** Display helper — returns a safe string copy (no HTML interpretation). */
export function safeText(value: string | null | undefined, fallback = "—"): string {
  if (value === null || value === undefined || value === "") return fallback;
  return value;
}
